import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from '@huge-monorepo/hip/directives';

@NgModule({
  declarations: [TooltipDirective],
  exports: [TooltipDirective],
  imports: [CommonModule],
})
export class CustomTooltipModule {}
